var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F9B300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3899 40.7143V38.3334C35.3899 37.0704 34.8973 35.8592 34.0205 34.9662C33.1437 34.0732 31.9545 33.5715 30.7146 33.5715H22.5327C21.2928 33.5715 20.1036 34.0732 19.2268 34.9662C18.35 35.8592 17.8574 37.0704 17.8574 38.3334V40.7143M36.5587 28.8096L38.8964 31.1905L43.5717 26.4286M31.299 24.0477C31.299 26.6776 29.2058 28.8096 26.6237 28.8096C24.0415 28.8096 21.9483 26.6776 21.9483 24.0477C21.9483 21.4177 24.0415 19.2858 26.6237 19.2858C29.2058 19.2858 31.299 21.4177 31.299 24.0477Z",
    stroke: "white",
    strokeWidth: 2.12553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.a4f8c0427efadfa17905e343df8e2f60.svg";
export { ForwardRef as ReactComponent };